<template>
  <div class="home-page">
    <!-- 顶部标题栏 -->
    <div class="header">
      <!-- <div class="header-left"></div> -->
      <div class="header-title">
        <div>
          <div class="titleChina">校园智慧指挥中心</div>
          <div class="titleEnglish">Campus Wisdom Command Center</div>
        </div>
        <span class="currentTime">{{ currentTime }}</span>
      </div>
      <!-- <div class="header-right">
        <span>{{ currentTime }}</span>
      </div> -->
    </div>
    <!-- 内容栏 -->
    <div class="article">
      <!-- 内容栏-左 -->
      <div class="article-left">
        <!-- 值班老师信息 -->
        <div class="duty-info">
          <div class="module-title">值班信息</div>
          <div class="teacher-list" @click="jumpDuty" v-if="homeData.dutyTeacher && homeData.dutyTeacher.length">
            <div class="teacher-item" v-for="(item, index) in homeData.dutyTeacher" :key="index">
              <div class="head-port">
                <el-avatar :size="60" src="https://empty" @error="errorHandler">
                  <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
                </el-avatar>
              </div>
              <div class="teacher-info">
                <div class="info">
                  <span class="text-left">{{ item.dutyType }}：</span>
                  <span class="text-right">{{ item.teacherName || '暂无' }}</span>
                </div>
                <div class="phone">
                  <span class="text-left">值班电话：</span>
                  <span class="text-right">{{ item.teacherPhone || '暂无' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="warn-text" v-else>暂无值班信息</div>
        </div>
        <!-- 最新公告 -->
        <div class="notice">
          <div class="module-title">最新公告</div>
          <div class="notice-list" @click="jumpNotice" v-if="homeData.schoolNews && homeData.schoolNews.length">
            <div class="notice-item" v-for="item in homeData.schoolNews" :key="item.id">
              <div class="title"><i class="el-icon-arrow-right icon"></i>{{ item.title }}</div>
              <div class="time">{{ item.createTime.slice(0, 10) }}</div>
            </div>
          </div>
          <div class="warn-text" v-else>暂无公告信息</div>
        </div>
      </div>
      <!-- 内容栏-中 -->
      <div class="article-center" @click="jumpUserInfo">
        <!-- 学校形象图轮播 -->
        <div class="school-img-carousel">
          <el-carousel indicator-position="outside" :height="carouselHeight">
            <el-carousel-item v-for="item in imgList" :key="item">
              <div class="overlay"></div>
              <el-image class="img" :src="item">
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 学校信息概览 -->
        <div class="school-info">
          <div class="module-title">学校概览</div>
          <div class="info-list">
            <div class="info-item">
              <div class="item-title">师生人数:</div>
              <div class="item-content">
                <i class="el-icon-s-data icon"></i>
                <div class="number">{{ homeData.schoolNum || 0 }}人</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">教师:</div>
              <div class="item-content">
                <i class="el-icon-s-custom icon"></i>
                <div class="number">{{ homeData.teacherNum || 0 }}人</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">学生:</div>
              <div class="item-content">
                <i class="el-icon-user-solid icon"></i>
                <div class="number">{{ homeData.studentNum || 0 }}人</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">场馆:</div>
              <div class="item-content">
                <i class="el-icon-school icon"></i>
                <div class="number">{{ homeData.venueNum || 0 }}个</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">年级:</div>
              <div class="item-content">
                <i class="el-icon-discount icon"></i>
                <div class="number">{{ homeData.gradeNum || 0 }}个</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">班级:</div>
              <div class="item-content">
                <i class="el-icon-price-tag icon"></i>
                <div class="number">{{ homeData.classNum || 0 }}个</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">宿舍:</div>
              <div class="item-content">
                <i class="el-icon-house icon"></i>
                <div class="number">{{ homeData.dormNum || 0 }}间</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">课室:</div>
              <div class="item-content">
                <i class="el-icon-office-building icon"></i>
                <div class="number">{{ homeData.classRoomNum || 0 }}个</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容栏-右 -->
      <div class="article-right">
        <!-- 考勤或请假情况饼图 -->
        <div class="condition-chart">
          <div class="module-title">图表情况</div>
          <div v-if="homeData.studentStatistics">
            <div class="chart-item" id="myChart" ref="chart"></div>
          </div>
          <div class="warn-text" v-else>暂无图表信息</div>
        </div>
        <!-- 考勤或请假情况列表 -->
        <div class="condition-list">
          <div class="module-title">学生情况</div>
          <el-table :data="homeData.studentInfo" class="condition-table" :max-height="tableMaxHeight">
            <el-table-column prop="studentName" label="姓名" :align="alignType">
            </el-table-column>
            <el-table-column prop="date" label="班级" :align="alignType">
              <template slot-scope="scope">
                <span>{{ scope.row.gradeName + scope.row.className }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="desc" :label="type == '事假' ? '请假原因' : '宿舍号'" :align="alignType">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "",
  data() {
    return {
      data: [],
      homeData: {}, // 首页数据
      currentTime: "", // 当前时间
      carouselHeight: "", // 轮播图高度
      myChart: null, // 图例
      alignType: 'center', // 表格对齐方式el
      imgList: ['../../assets/image/home/增江华附.jpg'],
      type: ""
    };
  },
  computed: {
    tableMaxHeight() {
      return `calc(100vh - 460px)`;
    }
  },
  created() {
    this.carouselHeight = window.innerHeight - 430 + "px";
    // this.getDutyTypeList(); // 查询值日类型
    // this.getDutyArea(); // 查询值日范围
  },
  mounted() {
    // 在组件挂载后立即获取当前时间
    this.getCurrentTime();
    this.getHomePageData();

    // 每隔一秒更新一次当前时间
    setInterval(() => {
      this.getCurrentTime();
    }, 1000);
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    hasPermission(permissionField) {
      // 如果menuPermissions为空，则从localStorage加载一次
      const permissions = window.localStorage.getItem("menuPermissions");
      let menuPermissions = permissions ? permissions.split(',') : [];
      return menuPermissions.includes(permissionField);
    },
    // 跳转公告页面
    jumpNotice() {
      if (!this.hasPermission('sc:news:query')) {
        return this.jumpUserInfo();
      };
      this.$router.push({
        path: "/notice",
      });
    },
    // 跳转值日编排页面
    jumpDuty() {
      if (!this.hasPermission('sc:duty:query')) {
        return this.jumpUserInfo();
      };
      this.$router.push({
        path: "/admin-duty-arrangement",
      });
    },
    // 跳转用户信息页面
    jumpUserInfo() {
      this.$router.push({
        path: "/userInfo",
      });
    },
    // 获取首页数据
    getHomePageData() {
      this.post(this.$url.getHomePageData, {
        schoolId: this.user.schoolId
      }).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.homeData = res.data;
        this.imgList = res.data.school.imageList.split(","); // 轮播图
        this.type = res.data.studentStatistics[0].type; // 判断当前时段是学生考勤还是宿舍
        setTimeout(() => {
          this.initChart(); // 初始化图表
        }, 500)
      })
    },
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    initChart() {
      var chartDom = document.getElementById("myChart");
      this.myChart = echarts.init(chartDom);
      var option;
      let data = [];
      this.homeData.studentStatistics.forEach(item => {
        data.push({
          value: item.number,
          name: item.type
        });
      });

      option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#58a55c', '#5087ec', '#68bbc4', '#ee6666'],
        legend: {
          top: '5%',
          left: 'center',
          textStyle: { color: '#fff' },
        },
        series: [
          {
            top: "10%",
            name: '人数统计',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#0f1230',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 30,
                fontWeight: 'bold',
                color: "#fff"
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };

      this.myChart.setOption(option);
    },
    errorHandler() {
      return true;
    },
    // 获取当前时间
    getCurrentTime() {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const weekDay = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ][now.getDay()];
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      this.currentTime = `${year}-${month}-${day} ${weekDay} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./homePage.scss";
</style>
